module.exports = __webpack_public_path__ + "static/img/homePage1.a5616d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-img/homePage1.png
// module id = 9XYD
// module chunks = 183